export class SmartAssetRecommendation {
  id:string;
  assetName: string;
  displayTitle: string;
  maintenanceCycle: MaintenanceCycle;
  propertyAddress: string;
  actionPerformDate:Date;
  propertyId:string;
  assignedManagerId:string;
  assetId: string;
  isRead:boolean;
  isRejected:boolean;
  nextCycleEndDate: Date;
}

export class SmartAssetRecommendationResults {
  assets: SmartAssetRecommendation[];
  pageTotal: number;
}

export enum MaintenanceCycle {
   None = -1,
   LessThanWeek = 0,
   InMonth = 1,
   InThreeMonths = 2,
   InSixMonths = 3,
   InYear = 4,
   WithinTwoYears = 5
  }
  